import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { WidgetData } from '../../../../_common/platform/ts/WidgetData';
import ClipboardCopy from '../../../../pdc-platform/src/tsx/ClipboardCopy';
import ConfigEdit from './ConfigEdit';

export default class PopupFooterComp extends React.Component<any, any> {
    constructor(props) {
        super(props);
        var widget;
    }

    cancelButtonHandler = () => {
        this.props.close();
    };

    applyButtonHandler = () => {
        if (typeof this.props.options.onInsert === 'function') {
            this.props.options.onInsert();
        }

        this.props.close();
    };

    handleKeyDown = (e) => {
        switch (e.code) {
            case 'Enter': // e.key = "Enter"
                //console.log("handleKeyDown Enter");
                e.stopPropagation();
                e.preventDefault();

                this.applyButtonHandler();
                break;

            case 'Escape': // e.key = "Escape"
                //console.log("handleKeyDown Enter");
                e.stopPropagation();
                e.preventDefault();

                this.cancelButtonHandler();
                break;
        }
    };

    render() {
        return (
            //left: this.props.options.offset.left,
            //top: this.props.options.offset.top,
            <div>
                <ClipboardCopy
                    isButtonWithGlyph={false}
                    text={this.props.text}
                    caption={'Copy to Clipboard'}
                    onClick={this.props.onClick}
                />
            </div>
        );
    }
}
